module.exports = __webpack_public_path__ + "img/qiancai-back-phone.b7b9b0f9.png";